<template>
    <div id="featured-posts" class="row">
        <div class="left-slider col-lg-7 pl-xs-1 pl-sm-1 pl-md-1 pl-lg-3">
            <carousel :data="slides"></carousel>
        </div>
        <div class="right-posts col-lg-5">
            <featured-blocks :data="blockItems"></featured-blocks>
        </div>
    </div>
</template>

<script>
    import FeaturedBlocks from "./FeaturedBlocks.vue";
    import SliderItem from "./SliderItem";
    import Vue from 'vue';
    import VueCarousel from '@chenfengyuan/vue-carousel';
    Vue.use(VueCarousel);
    import AppFilters from "../../filters/AppFilters";
    import { mapGetters } from 'vuex'
    import { resizedThumbnail } from "../../helpers/helpers";

    export default {
        name: 'FeaturedPosts',
        props: ['data'],
        components: {
            FeaturedBlocks,
            SliderItem
        },
        data() {
            return {
                slides: [],
                blockItems: this.getBlockItems,
                slideItems: this.getSlideItems,
            }
        },
        computed: {
            ...mapGetters([
                'getSlideItems',
                'getBlockItems'
            ]),
        },
        created() {

        },
        methods: {
            loadFeaturedItems() {
                for(let i=0 ; i < this.slideItems.length; i++) {
                    this.slides.push('' +
                        '<div class="featured-post">' +
                        '<div class="post-content">' +
                        '<a class="post-cat" href="'+this.slideItems[i].keywords_search_url+'">'+this.slideItems[i].first_keyword+'</a>' +
                        '<h2 class="post-title title-extra-large">' +
                        '<a href="'+this.slideItems[i].post_url+'">'+this.slideItems[i].title+'</a>' +
                        '</h2>' +
                        '<span class="post-date">'+AppFilters.filters.formatShortDate(this.slideItems[i].creation_date)+'</span>' +
                        '</div>' +
                        '</div>' +
                        '<img src="'+this.resizedThumbnail(this.slideItems[i].photo, 460)+'"/>'
                    );
                }
            },
            resizedThumbnail(url, height) {
                return resizedThumbnail(url, height);
            }
        },
        mounted() {

        },
        watch: {
            data: function(newVal) {

            },
            getSlideItems: function(newVal) {
                this.slideItems = newVal;
                this.loadFeaturedItems();
            },
            getBlockItems: function(newVal) {
                this.blockItems = newVal;
            }
        }
    }
</script>

<style lang="scss">
    #featured-posts {
        margin-top: 45px;

        .left-slider {
            height: 465px;
            padding: 0px 0px 0px 15px;

            .carousel__list {
                height: 465px;
            }
            .carousel__item {

                img {
                    height: 465px;
                }

                .featured-post:before {
                    content: " ";
                    position: absolute;
                    display: block;
                    width: 100%;
                    height: 100%;
                    z-index: 1;
                    bottom: 0;
                    left: 0;
                    background: -moz-linear-gradient(top, rgba(0, 0, 0, 0) 40%, rgba(0, 0, 0, 0.85) 100%);
                    background: -webkit-gradient(linear, left top, left bottom, color-stop(60%, rgba(0, 0, 0, 0)), color-stop(100%, rgba(0, 0, 0, 0.85)));
                    background: -webkit-linear-gradient(top, rgba(0, 0, 0, 0) 40%, rgba(0, 0, 0, 0.85) 100%);
                    background: -o-linear-gradient(top, rgba(0, 0, 0, 0) 40%, rgba(0, 0, 0, 0.85) 100%);
                    background: -ms-linear-gradient(top, rgba(0, 0, 0, 0) 40%, rgba(0, 0, 0, 0.85) 100%);
                    background: linear-gradient(to top, rgba(0, 0, 0, 0) 40%, rgba(0, 0, 0, 0.85) 100%);
            }

                .featured-post {
                    position: absolute;

                    .post-content {
                        padding: 30px;
                        z-index: 1;
                        position: relative;

                        a.post-cat {
                            position: relative;
                            font-size: 10px;
                            padding: 0 5px;
                            background: #1c1c1c;
                            text-transform: uppercase;
                            font-weight: 700;
                            color: #fff;
                            height: 20px;
                            line-height: 20px;
                            display: inline-block;
                        }

                        .post-cat:before {
                            content: '';
                            position: absolute;
                            left: 0;
                            z-index: 0;
                            bottom: -8px;
                            border-top: 8px solid #1c1c1c;
                            border-right: 8px solid transparent;
                        }

                        .post-title.title-extra-large {
                            font-size: 26px;
                            line-height: 30px;
                            margin-top: 15px;
                            margin-bottom: 10px;
                        }

                        .post-date, .post-title a {
                            color: #fff;
                        }
                    }
                }
            }
        }

        .right-posts {
            padding: 0px;
        }
    }
</style>